import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { ShiftHeader, ShiftHeading } from '../../../components/ShiftTable/layout'
import { Button } from '../../../components/Button'
import { BigButtonSection } from '../../../components/layout'
import { AddEventPage } from '../AddEvent'
import { EventTypeOption, NoShiftPageViews, ShiftPageProps } from '../types'
import { messages } from '../messages'

export const NoShiftPage: React.FunctionComponent<ShiftPageProps> = ({ currentShift, refetch, shiftGroup }) => {
  const [view, setView] = useState<NoShiftPageViews>(NoShiftPageViews.default)
  const { formatMessage } = useIntl()
  return (
    <>
      {view === NoShiftPageViews.default && (
        <ShiftHeader color="grey300">
          <ShiftHeading label={formatMessage(messages.noShiftStatus)} />
          <BigButtonSection>
            <Button
              category="new"
              label={formatMessage(messages.startWork)}
              onClick={() => {
                setView(NoShiftPageViews.work_start_form)
              }}
              size="m"
              fontWeight="normal"
              maxWidth={shiftGroup && shiftGroup.enableStandby ? '100%' : undefined}
            />
            {shiftGroup && shiftGroup.enableStandby && (
              <Button
                category="new"
                label={formatMessage(messages.startStandby)}
                size="m"
                fontWeight="normal"
                maxWidth="100%"
                onClick={() => {
                  setView(NoShiftPageViews.standby_start_form)
                }}
              />
            )}
          </BigButtonSection>
        </ShiftHeader>
      )}

      {view === NoShiftPageViews.work_start_form && (
        <AddEventPage
          type={EventTypeOption.work_start}
          onClose={() => setView(NoShiftPageViews.default)}
          shift={currentShift}
          refetch={refetch}
        />
      )}

      {view === NoShiftPageViews.standby_start_form && (
        <AddEventPage
          type={EventTypeOption.standby_start}
          onClose={() => setView(NoShiftPageViews.default)}
          shift={currentShift}
          refetch={refetch}
        />
      )}
    </>
  )
}
